import { useFormikContext } from 'formik'
import React from 'react'
import type { AppleWalletPassConfigInput } from '../../../../../types/loyalty'
import { RuleCard } from '../rules/RuleCard'
import { WalletTextField } from './WalletTextField'

const Icon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M4 4h16v4H4z" />
    <path d="M4 12h16v8H4z" />
    <path d="M8 16h6" />
  </svg>
)

export const AppleWalletDetailsCard: React.FC = () => {
  const { values, errors, touched, setFieldValue, setFieldTouched } =
    useFormikContext<AppleWalletPassConfigInput>()

  const change =
    (key: keyof AppleWalletPassConfigInput) =>
    (next: string) => {
      setFieldValue(key, next)
      if (!touched[key]) setFieldTouched(key, true, false)
    }

  const errorFor = (key: keyof AppleWalletPassConfigInput) =>
    touched[key] ? (errors[key] as string | undefined) : undefined

  return (
    <RuleCard title="Apple Wallet Details" icon={<Icon />}>
      <WalletTextField
        label="Logo text"
        value={values.logo_text}
        placeholder="My Store"
        helperText="Text displayed next to the logo on the pass"
        error={errorFor('logo_text')}
        onChange={change('logo_text')}
      />
      <WalletTextField
        label="Organization name"
        value={values.organization_name}
        placeholder="My Organization"
        helperText="Organization name shown on the pass"
        error={errorFor('organization_name')}
        onChange={change('organization_name')}
      />
      <WalletTextField
        label="Description"
        value={values.description}
        placeholder="Loyalty card for My Store"
        helperText="Pass description"
        error={errorFor('description')}
        onChange={change('description')}
        multiline
        rows={3}
      />
    </RuleCard>
  )
}
